import React from 'react'

const index = () => {
  return (
    <div>Package Groups</div>
  )
}

export default index